import { Card, Flex, Skeleton, Timeline, Typography } from "antd";
import { ActivityLogInterface } from "api/activity/dto";
import { useGetRecruiterActivity } from "api/activity/useGetRecruiterActivity";
import ErrorPage from "components/ui/ErrorPage";
import React from "react";
import { formatDate } from "utils/date";

const { Title, Text } = Typography;

const color = ["red", "green", "#00CCFF"];

const RecruiterActivity = () => {
  const { data, isFetching, error } = useGetRecruiterActivity();

  const items = data?.map((i: ActivityLogInterface) => {
    const randomIndex = Math.floor(Math.random() * color.length);
    return {
      color: color[randomIndex],
      label: formatDate(i?.createdAt),
      children: (
        <Flex vertical>
          <Title level={5} style={{ color: "#374151", textTransform: "capitalize" }}>
            {i?.actionType?.replace(/_/g, "  ")}
          </Title>
          <Text type="secondary" style={{ fontSize: "16px" }}>
            {i?.description}
          </Text>
        </Flex>
      ),
    };
  });

  if (isFetching) {
    return (
      <div className="bg-background">
        <div className="max-w-6xl mx-auto py-12">
          <Card style={{ width: "100%", marginTop: 16, height: "580px" }}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </Card>
        </div>
      </div>
    );
  }

  if (error) {
    return <ErrorPage error={error} />;
  }
  return (
    <>
      <div className="bg-background">
        <div className="max-w-6xl mx-auto py-12">
          <Card>
            <Title level={2} style={{ fontWeight: 700 }}>
              Activity log
            </Title>

            <Timeline mode={"left"} items={items} className="mt-12" />
          </Card>
        </div>
      </div>
    </>
  );
};

export default RecruiterActivity;
